module.exports = __webpack_public_path__ + "static/estelandry-5a07bbe455442f4e1f517ff6f0cd214a.png";